<div class="payment-methods-container">
  <app-smart-grid
    [columnDefs]="columnDefs"
    [data]="paymentData()"
    [config]="gridConfig">
  </app-smart-grid>
</div>
